import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { FileTransferPhase, FileTransferStatusRow } from './file-transfer.models';

@Component({
  selector: 'app-file-transfer-status-list',
  imports: [CommonModule],
  templateUrl: './file-transfer-status-list.component.html',
  styleUrl: './file-transfer-status-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileTransferStatusListComponent {
  readonly rows = input<readonly FileTransferStatusRow[]>([]);

  protected alertClass(phase: FileTransferPhase): string {
    switch (phase) {
      case 'completed':
        return 'alert-success';
      case 'failed':
        return 'alert-danger';
      default:
        return 'alert-warning';
    }
  }

  protected showProgress(row: FileTransferStatusRow): boolean {
    return row.phase === 'transferring' && row.progressPercent !== null;
  }
}
